export default __webpack_public_path__ + "static/media/machinery.2a782ba9.jpg";